export enum EordersTypes {
  buy = "buy",
  sell = "sell",
  suspended = "suspended",
}
